/// <amd-module name="Artifacts/Package/types/ILogoProps" />
export interface ILogoProps {
  className: string;
}
